import * as Yup from "yup";
import {equipmentSchema} from "./equipmentSchema";
import {changeRequestSchema} from "./changeRequestSchema";

export const workOrderSchema = Yup.object().shape({
  requestDate: Yup.date(), // 요청 날짜
  checkType: Yup.number(), // 기기점검 구분  0 - 기타, 1 - 점검, 2 - 예방, 3 - 예측, 4 - 고장
  processDepartmentUID: Yup.number(), // 진행 부서 UID - EQDepartment

  // note Statistics
  statisticsCategory: Yup.number(), // 통계번호 - 유형
  statisticsItem: Yup.number(), // 통계번호 - 장치
  statistics2: Yup.number(), // 통계번호 - 상태
  isChangable: Yup.boolean(), // 변경 가능 여부
  requestContent: Yup.string(), // 요청 내용

  // note base64
  preFileBase64: Yup.string(),
  etcFileBase64: Yup.string(),

  repairContent: Yup.string(), // 수리 내용
  rejectContent: Yup.string(), // 반려 내용
  delayContent: Yup.string(), // 지연 내용

  // note manual
  // // note 설비 점검 이력
  // evaluation2File: Yup.string(), // 평가 자료 파일2
  // education1File: Yup.string(), // 교육 자료 파일1
  // education2File: Yup.string(), // 교육 자료 파일2

  // // note base64
  // evaluation2FileBase64: Yup.string(),
  // education1FileBase64: Yup.string(),
  // education2FileBase64: Yup.string(),
  // fireWorkFileBase64: Yup.string(),
  // generalFileBase64: Yup.string(),

  // // note 수동 체크
  // isHeight: Yup.boolean(), // 고소
  // isClosed: Yup.boolean(), // 밀폐
  // isStopElectricity: Yup.boolean(), // 정전
  // isExcavation: Yup.boolean(), // 굴착
  // isHeavy: Yup.boolean(), // 중장비
  // isRadiation: Yup.boolean(), // 방사선

  // startDate: Yup.date(), // 시작일
  // completeDate: Yup.date(), //  - 완료일
  // workedHours: Yup.number(), // 작업 소요 시간
  // cost: Yup.number(),

  // preCheckFileBase64: Yup.string(),
  // attachmentBase64: Yup.string(),
  // postFileBase64: Yup.string(),
  // externalComment: Yup.string(), // 비고
  // changeEvalFileBase64: Yup.string(),

  // note not used
  // uid: Yup.number(),
  // guid: Yup.string(),
  // specificationUID: Yup.number(), // 기기 UID - EQSpecification
  // writerUID: Yup.number(), // 작성자 UID - EQUser
  // companyUID: Yup.number(), // 업체 UID - EQCompany
  // writerDepartmentUID: Yup.number(), // 작성 부서 UID - EQDepartment

  // priority: Yup.number(), // 우선순위

  // statusIndex: Yup.number(), // 상태 -  요청 - 0, 접수/진행 - 1, 반려 - 2, 지연 - 3, 완료 - 4

  // // File - 2020-07-29 New Entry
  // evaluation1File: Yup.string(), // 평가 자료 파일1
  // fireWorkFile: Yup.string(), // 화기 작업 자료 파일
  // generalFile: Yup.string(), // 일반 작업 자료 파일
  // changeRequestFile: Yup.string(), // 변경 요구서 파일
  // preCheckFile: Yup.string(), // 사전 점검 파일
  // changeEvalFile: Yup.string(), // 변경 평가 파일

  // // Entry Field
  // serialNo: Yup.number(), // 일련번호
  // writeDate: Yup.date(), // 작성일
  // department: Yup.string(), // 부서명
  // writerName: Yup.string(), // 작성자

  // // Receive Phase 설비점검이력
  // receiverUID: Yup.number(), // 수신자 UID - EQUser UID
  // repairCompany: Yup.string(), // 협력업체명
  // isOutsourcing: Yup.boolean(), // 외부업체 여부

  // evaluation1: Yup.date(), // 평가 일시 1
  // evaluation2: Yup.date(), // 평가 일시 2
  // education1: Yup.date(), // 교육 일시 1
  // education2: Yup.date(), // 교육 일시 2

  // // Process Stage Properties
  // estimatedDate: Yup.date(), // 완료 예정일자 - 예상시작일자 - 요청일자가 기본값
  // processorUID: Yup.number(), // 진행자 UID - EQUser UID

  // // Complete Phase
  // attachment: Yup.string(), // 자료등록 //
  // isLastConfirmed: Yup.boolean(), // 관리자확인

  // //Attachments
  // preFile: Yup.string(), // - 개선 전 파일
  // postFile: Yup.string(), // - 개선 후 파일
  // etcFile: Yup.string(), // 관련자료

  // //변경이력서
  // changeRequestUID: Yup.number(), // 변경 이력서 UID - EQChangeRequest UID (추후)

  // entryDate: Yup.date(), // 작성일

  // // -------------------------------------------------- No DB -------------------------------------------;
  // receiverName: Yup.string(), // 접수자

  // // Base64
  // evaluation1FileBase64: Yup.string(),
  // changeRequestFileBase64: Yup.string(),

  // // Nested Object
  // specification: Yup.array().of(equipmentSchema), // 설비 유지
  // changeRequest: Yup.array().of(changeRequestSchema), // 변경 요구서
});
